
import React from 'react';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar';
import { SidebarHeader as CustomSidebarHeader } from '@/components/sidebar/SidebarHeader';
import { MainNavigationSection } from '@/components/sidebar/MainNavigationSection';
import { CourseNavigationSection } from '@/components/sidebar/CourseNavigationSection';
import { ManagementNavigationSection } from '@/components/sidebar/ManagementNavigationSection';

const ModernSidebar = () => {
  return (
    <Sidebar variant="inset" className="border-r">
      <SidebarHeader>
        <CustomSidebarHeader />
      </SidebarHeader>
      
      <SidebarContent>
        <MainNavigationSection />
        <CourseNavigationSection />
        <ManagementNavigationSection />
      </SidebarContent>
      
      <SidebarRail />
    </Sidebar>
  );
};

export default ModernSidebar;
